import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './TemplatesGalleryBanner.less';

// eslint-disable-next-line @trello/assets-alongside-implementation
import templateGalleryBannerSvg from 'resources/images/template-gallery-banner.svg';

export const TemplatesGalleryBanner: FunctionComponent = () => {
  return (
    <div className={styles.banner}>
      <div className={styles.bannerBorder}>
        <div className={styles.bannerText}>
          <h1 className={styles.bannerHeading}>
            <FormattedMessage
              id="templates.templates.templates-for-trello"
              defaultMessage="Templates for Trello"
              description="The title of the button for templates used in Trello"
            />
          </h1>
          <p className={styles.bannerParagraph}>
            <FormattedMessage
              id="templates.templates.templates-banner-copy"
              defaultMessage="No more starting from scratch. Give your team a blueprint for success with tried-and-true templates from the Trello community. Copy, customize, and you’ll be collaborating in no time!"
              description="The copy of the banner that explains the benefit of using templates from the Trello community"
            />
          </p>
        </div>
        <img
          alt=""
          role="presentation"
          className={styles.bannerIcon}
          src={templateGalleryBannerSvg}
        />
      </div>
    </div>
  );
};
